import { render, staticRenderFns } from "./ComprovanteMarcacao.vue?vue&type=template&id=72620614&"
import script from "./ComprovanteMarcacao.vue?vue&type=script&lang=js&"
export * from "./ComprovanteMarcacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports